<template>
    <div class="wayBillSummary">
        <div class="wayBillSection">
            <div class="section-title">
                运单汇总
                <i
                    :class="
                        wayBillSummaryLoading
                            ? 'el-icon-loading'
                            : 'el-icon-refresh'
                    "
                    @click="$emit('refresh-wayBillSummary')"
                ></i>
            </div>
            <div class="section-content">
                <div class="unfinishedTask">
                    <span>未完成运单</span>
                    <span>{{ processingNumber }}</span>
                </div>
                <div class="exceptionTask">
                    <span>异常运单</span>
                    <span>{{ exceptionNumber }}</span>
                </div>
            </div>
        </div>
        <div class="wayBillSection echarts">
            <div class="section-title">
                任务汇总
                <i
                    :class="
                        taskSummaryLoading
                            ? 'el-icon-loading'
                            : 'el-icon-refresh'
                    "
                    @click="$emit('refresh-taskSummary')"
                ></i>
            </div>
            <div class="echart-container" v-loading="taskSummaryLoading">
                <div id="taskSummary" style="height: 100%"></div>
            </div>
        </div>
        <span class="slideBar" @click="handleExpand">
            <i class="el-icon-d-arrow-left"></i>
        </span>
    </div>
</template>
<script>
export default {
    name: 'wayBillSummary',
    props: {
        // 未完成订单数
        processingNumber: {
            type: Number,
            default: 0
        },
        // 异常订单数
        exceptionNumber: {
            type: Number,
            default: 0
        }
    },
    data () {
        return {
            wayBillSummaryLoading: false,
            taskSummaryLoading: false,
            echarts: null
        };
    },
    methods: {
        // 初始化Echarts数据
        initEcharts (options) {
            this.echarts && this.echarts.dispose();
            setTimeout(() => {
                this.echarts = this.$echarts.init(document.getElementById('taskSummary'));
                this.echarts && options && this.echarts.setOption(options);
            }, 100);
        },
        handleExpand () {
            this.$emit('isExpand');
        }
    }
};
</script>

<style lang="less">
.wayBillSummary {
    width: 100%;
    height: 100%;
    background-color: #fff;
    box-shadow: 0 0 12px 1px #f1f1f1;
    transition: transform 0.5s;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 10;
    &.expanded {
        transform: translateX(calc(100% + 16px));
    }
    .wayBillSection {
        .section-title {
            line-height: 36px;
            font-size: 14px;
            padding: 0 15px;
            box-sizing: border-box;
            background-color: #f1f1f1;
        }
        .section-content {
            display: flex;
            justify-content: space-between;
            padding: 15px 10px;
            .unfinishedTask,
            .exceptionTask {
                width: 50%;
                height: 80px;
                color: #fff;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                margin: 0 5px;
                & > span:first-child {
                    margin-bottom: 10px;
                    font-size: 14px;
                }
            }
            .unfinishedTask {
                background-color: #42a5fa;
            }
            .exceptionTask {
                background-color: #ff4b6e;
            }
        }
        &.echarts {
            height: calc(100% - 146px);
            .echart-container {
                height: calc(100% - 36px);
            }
        }
    }
    .slideBar {
        position: absolute;
        left: -20px;
        top: 50%;
        margin-top: -20px;
        display: block;
        width: 20px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background-color: #ddd;
        cursor: pointer;
        i {
            color: #000;
        }
    }
    .el-icon-refresh,
    .el-icon-loading {
        margin-left: 5px;
        cursor: pointer;
        color: #00bcbf;
    }
}
</style>